import { useLocation } from 'react-router-dom';
import { Flex, Box, Text } from "@chakra-ui/react";
import LaunchdeckButton from './LaunchdeckButton';
import { redirectToNewPage } from '../../../helpers/global-helpers';
import LoggedOutConfirmationModal from '../../../../digital-sales-room/dsr-general-mgmt/LoggedOutConfirmationModal';
import SleepingMascotImage from './SleepingMascotImage';


export default function InvalidRequestPage() {

	const location = useLocation();
	const { redirectionUri } = location.state || {};

	return (

		<Flex direction="column" align="center" bg='white' p='3%' mb='2em' rounded='0.8em'>
			<Box fontSize='1.2em' fontWeight='600'>Page not found, oops!  </Box>

			<SleepingMascotImage />

			<Text mt='0.2em'>Instead, you've found Gnocco, our Chief Doggo Officer, napping.</Text>
			<Text mt='0.2em' color='gray.600'>Very quiet now...</Text>

			<Flex mt='2em' justify='center'>
				<LaunchdeckButton bg='brand.500' color='white' fontSize='0.875em' onClick={() => redirectToNewPage(redirectionUri || '/home')} label='Ssshh...quietly head back?' />
			</Flex>
			<LoggedOutConfirmationModal />
		</Flex>
	)
}

